import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import SettingsIcon from '@mui/icons-material/Settings';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import VideoLabelIcon from '@mui/icons-material/VideoLabel';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/styles": { styled }, "@mui/material/Stack": Stack, "@mui/material/Stepper": Stepper, "@mui/material/Step": Step, "@mui/material/StepLabel": StepLabel, "@mui/icons-material/Check": Check, "@mui/icons-material/Settings": SettingsIcon, "@mui/icons-material/GroupAdd": GroupAddIcon, "@mui/icons-material/VideoLabel": VideoLabelIcon, "@mui/material/StepConnector": StepConnector } } });
export default ClientProvider;
